import LandingPage from '../../components/LandingPage'
import RegoForm from '../../components/RegoForm'
import InitialLoading from '../../components/RegoForm/pages/InitialLoading'
import PaymentComplete from '../../components/RegoForm/pages/PaymentComplete'
import PaymentResponse from '../../components/RegoForm/pages/PaymentResponse'
import { topRoutes } from './routes'

const routesMap = {
  landingPage: LandingPage,
  eventLandingPage: LandingPage,
  eventRego: RegoForm,
  registrationForm: RegoForm,
  membershipRego: InitialLoading,
  paymentResponse: PaymentResponse,
  paymentComplete: PaymentComplete,
}

export default topRoutes.reduce((acc, route) => {
  if (Object.hasOwn(routesMap, route.id)) {
    // eslint-disable-next-line no-param-reassign
    route.component = routesMap[route.id]
  }
  acc.push(route)
  return acc
}, [])
